import { httpInterceptor } from './interceptor';

export async function getResultsLog(groupId) {
  const response = await httpInterceptor.get(`schools/group/${groupId}/results-log`);
  return response.data;
}

export async function saveResultsLog(groupId, payload) {
  const response = await httpInterceptor.put(`schools/group/${groupId}/results-log`, payload);
  return response.data;
}

export async function downloadResultsLog(groupId, revision) {
  try {
    return await httpInterceptor.get(`schools/group/${groupId}/results-log/pdf`, {
      params: { revision },
      responseType: 'blob'
    });
  } catch (error) {
    if (error?.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch (_) {
        // Preserve the original HTTP error if the server did not return JSON.
      }
    }
    throw error;
  }
}

export async function getFinalizedResultsLogs() {
  const response = await httpInterceptor.get('schools/results-logs/finalized');
  return response.data;
}

export async function downloadFinalizedResultsLogsArchive() {
  return await httpInterceptor.get('schools/results-logs/finalized/archive', {
    responseType: 'blob'
  });
}
